import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "@/utils/api";

const AuthCallbackPage = () => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = window.location.hash;
      
      // Clear any old cached data first
      localStorage.removeItem('token');
      localStorage.removeItem('userCurrency');
      localStorage.removeItem('userCurrencyTime');
      
      // Check for token in hash (from Google/Facebook OAuth)
      const tokenMatch = hash.match(/token=([^&]+)/);
      if (tokenMatch) {
        const token = tokenMatch[1];
        localStorage.setItem('token', token);
        toast.success("Welcome to BidZuu!");
        // Force full page reload to clear all state
        window.location.href = '/';
        return;
      }
      
      // Check for Google session_id (legacy Emergent auth)
      const sessionId = hash.split('session_id=')[1]?.split('&')[0];

      if (sessionId) {
        try {
          const response = await api.post("/auth/google/session", {}, {
            headers: { "X-Session-ID": sessionId }
          });
          localStorage.setItem('token', response.data.token);
          toast.success("Welcome to BidZuu!");
          window.location.href = '/';
        } catch (error) {
          toast.error("Authentication failed");
          navigate('/', { replace: true });
        }
      } else {
        navigate('/', { replace: true });
      }
    };

    processAuth();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin h-8 w-8 border-4 border-emerald-500 border-t-transparent rounded-full mx-auto mb-4" />
        <p>Signing you in...</p>
      </div>
    </div>
  );
};

export default AuthCallbackPage;
